import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AttributionService } from '../services/attribution.service';

@Component({
  selector: 'app-parceiros',
  standalone: true,
  imports: [FormsModule],
  template: `
    <div class="min-h-screen bg-[#111111] text-white">

      <!-- Header with logo -->
      <div class="px-6 py-6">
        <img src="/images/logo-branca.svg" alt="beetrack" class="h-8 w-auto" width="120" height="32">
      </div>

      <!-- HERO -->
      <section class="px-4 pt-10 pb-16 max-w-3xl mx-auto text-center">
        <div class="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#FF5500]/10 border border-[#FF5500]/30 text-[#FF5500] text-xs font-bold tracking-widest uppercase mb-8">
          💰 PROGRAMA DE PARCEIROS — VAGAS LIMITADAS
        </div>

        <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.15] mb-6">
          Seus clientes já têm o problema.<br>
          Você já tem a confiança deles.<br>
          <span class="text-[#FF5500]">Falta só a solução certa.</span>
        </h1>

        <p class="text-gray-300 text-lg md:text-xl font-medium mb-6 leading-relaxed">
          Técnicos de Segurança do Trabalho e Ergonomistas que trabalham com indústrias frigorificadas estão deixando dinheiro na mesa todo mês — sem saber.
        </p>

        <p class="text-gray-400 text-base leading-relaxed max-w-2xl mx-auto mb-10">
          Todo cliente seu que tem câmara fria está em risco legal agora mesmo. A NR 36 obriga o controle da pausa térmica. A fiscalização do MTE está aumentando. E quando a multa chegar, seu cliente vai lembrar de você — da forma errada.<br><br>
          A beetrack resolve isso de vez. E desde 2019 já protegeu mais de 300 operações no Brasil inteiro com a solução mais robusta juridicamente do mercado. Agora, pela primeira vez, abrimos nossa política comercial para parceiros indicadores e revendedores qualificados.
        </p>

        <!-- Destaque -->
        <div class="text-2xl md:text-3xl font-extrabold text-[#FF5500] py-6 border-t border-b border-[#FF5500]/20">
          Você indica. A beetrack entrega. Você recebe.
        </div>
      </section>

      <!-- CARDS -->
      <section class="px-4 pb-16 max-w-5xl mx-auto">
        <div class="grid md:grid-cols-3 gap-6">

          <div class="bg-[#1a1a1a] border border-white/8 rounded-2xl p-7 flex flex-col gap-4 hover:border-[#FF5500]/30 transition-colors">
            <div class="text-3xl">⚖️</div>
            <h3 class="text-lg font-bold text-white">Solução que vende sozinha</h3>
            <p class="text-gray-400 text-sm leading-relaxed">
              Relatórios aceitos por peritos e juízes trabalhistas. Equipamentos homologados pela Anatel com certificação IP67. Seu cliente só começa a pagar depois do sistema funcionando.
            </p>
          </div>

          <div class="bg-[#1a1a1a] border border-white/8 rounded-2xl p-7 flex flex-col gap-4 hover:border-[#FF5500]/30 transition-colors">
            <div class="text-3xl">🔌</div>
            <h3 class="text-lg font-bold text-white">Plug & play — zero dor de cabeça</h3>
            <p class="text-gray-400 text-sm leading-relaxed">
              Instalação simples e remota. Suporte 100% da beetrack. Você só precisa conectar o cliente — o resto é com a gente.
            </p>
          </div>

          <div class="bg-[#1a1a1a] border border-white/8 rounded-2xl p-7 flex flex-col gap-4 hover:border-[#FF5500]/30 transition-colors">
            <div class="text-3xl">💰</div>
            <h3 class="text-lg font-bold text-white">Comissão recorrente todo mês</h3>
            <p class="text-gray-400 text-sm leading-relaxed">
              Não é uma venda única. É uma renda que cresce enquanto sua carteira de clientes cresce.
            </p>
          </div>

        </div>
      </section>

      <!-- FORMULÁRIO -->
      <section class="px-4 pb-20 max-w-xl mx-auto">
        <div class="bg-[#161616] border border-white/10 rounded-2xl p-8 md:p-10">

          <h2 class="text-2xl font-bold text-white mb-2 leading-snug">
            Quero entender como funciona e quanto posso ganhar →
          </h2>
          <p class="text-gray-400 text-sm mb-8">
            Sem compromisso. Nossa equipe entra em contato em até 2h úteis.
          </p>

          @if (!submitted) {
          <form (ngSubmit)="onSubmit()" #f="ngForm" class="flex flex-col gap-5">

            <div class="flex flex-col gap-1.5">
              <label class="text-gray-300 text-sm font-medium">Nome completo *</label>
              <input type="text" [(ngModel)]="nome" name="nome" required
                     placeholder="Ex: João Silva"
                     class="bg-[#1f1f1f] border border-white/10 focus:border-[#FF5500] outline-none rounded-lg px-4 py-3 text-white text-sm placeholder-gray-600 transition-colors" />
            </div>

            <div class="flex flex-col gap-1.5">
              <label class="text-gray-300 text-sm font-medium">WhatsApp *</label>
              <input type="tel" [(ngModel)]="whatsapp" name="whatsapp" required
                     placeholder="(11) 99999-9999"
                     class="bg-[#1f1f1f] border border-white/10 focus:border-[#FF5500] outline-none rounded-lg px-4 py-3 text-white text-sm placeholder-gray-600 transition-colors" />
            </div>

            <div class="flex flex-col gap-1.5">
              <label class="text-gray-300 text-sm font-medium">Empresa *</label>
              <input type="text" [(ngModel)]="empresa" name="empresa" required
                     placeholder="Ex: Consultoria SST Ltda"
                     class="bg-[#1f1f1f] border border-white/10 focus:border-[#FF5500] outline-none rounded-lg px-4 py-3 text-white text-sm placeholder-gray-600 transition-colors" />
            </div>

            <div class="flex flex-col gap-1.5">
              <label class="text-gray-300 text-sm font-medium">Cargo *</label>
              <input type="text" [(ngModel)]="cargo" name="cargo" required
                     placeholder="Ex: Técnico de Segurança do Trabalho"
                     class="bg-[#1f1f1f] border border-white/10 focus:border-[#FF5500] outline-none rounded-lg px-4 py-3 text-white text-sm placeholder-gray-600 transition-colors" />
            </div>

            <div class="flex flex-col gap-1.5">
              <label class="text-gray-300 text-sm font-medium">Email corporativo *</label>
              <input type="email" [(ngModel)]="email" name="email" required
                     placeholder="Ex: joao@empresa.com.br"
                     class="bg-[#1f1f1f] border border-white/10 focus:border-[#FF5500] outline-none rounded-lg px-4 py-3 text-white text-sm placeholder-gray-600 transition-colors" />
            </div>

            <button type="submit" [disabled]="!isFormValid() || loading"
                    class="w-full bg-[#FF5500] hover:bg-[#E04800] disabled:bg-[#333] disabled:text-gray-500 disabled:cursor-not-allowed text-white font-bold py-4 rounded-xl text-base transition-all shadow-lg hover:shadow-[#FF5500]/30 mt-2">
              {{ loading ? 'Enviando...' : 'Quero ser um parceiro beetrack →' }}
            </button>

          </form>
          }

          @if (submitted) {
          <div class="text-center py-6">
            <div class="text-4xl mb-4">✅</div>
            <p class="text-white font-semibold text-lg">Recebemos seu contato!</p>
            <p class="text-gray-400 text-sm mt-2">Redirecionando...</p>
          </div>
          }

        </div>
      </section>

      <!-- Footer note -->
      <p class="text-center text-gray-600 text-sm pb-10">
        © {{ currentYear }} beetrack Tecnologia Ltda. Todos os direitos reservados.
      </p>

    </div>
  `
})
export class ParceirosComponent {
  router = inject(Router);
  private attributionService = inject(AttributionService);
  currentYear = new Date().getFullYear();

  nome = '';
  whatsapp = '';
  empresa = '';
  cargo = '';
  email = '';
  loading = false;
  submitted = false;

  isFormValid(): boolean {
    return this.nome.trim().length > 2 &&
           this.whatsapp.trim().length > 8 &&
           this.empresa.trim().length > 1 &&
           this.cargo.trim().length > 1 &&
           this.email.trim().includes('@');
  }

  onSubmit() {
    if (!this.isFormValid()) return;
    this.loading = true;

    const attribution = this.attributionService.getAttribution();
    const sheetsPayload = {
      nome: this.nome,
      whatsapp: this.whatsapp,
      empresa: this.empresa,
      cargo: this.cargo,
      email: this.email,
      tipo: 'parceiro',
      ...attribution
    };

    const sheetsQs = new URLSearchParams(
      Object.fromEntries(Object.entries(sheetsPayload).map(([k, v]) => [k, String(v)]))
    );
    const sheetsCall = fetch(
      'https://script.google.com/macros/s/AKfycbyTpi3oJwO4IRrQsgmIn-X6ttglrm0BO1z3eY_rqIN8X2lyzkZsbPebbfekzV6G2pXzxA/exec?' + sheetsQs.toString(),
      { method: 'GET', mode: 'no-cors' }
    ).catch(() => {});

    const zapiMessage =
      `🤝 Novo parceiro interessado!\n\n` +
      `👤 Nome: ${this.nome}\n` +
      `📱 WhatsApp: ${this.whatsapp}\n` +
      `🏢 Empresa: ${this.empresa}\n` +
      `💼 Cargo: ${this.cargo}\n` +
      `📧 Email: ${this.email}`;

    const zapiCall = fetch(
      'https://api.z-api.io/instances/3ECE3973688CB2D7C0AEDAD6DC7CFA85/token/8E52C9D13FA51E01BF764651/send-text',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Client-Token': 'F0401d12a05d94085ad4f4f14c353f1a0S'
        },
        body: JSON.stringify({ phone: '120363411172685496-group', message: zapiMessage })
      }
    ).catch(() => {});

    Promise.all([sheetsCall, zapiCall])
      .catch(() => {})
      .finally(() => {
        this.submitted = true;
        this.loading = false;
        setTimeout(() => {
          this.router.navigate(['/obrigado']);
        }, 1500);
      });
  }
}
